import { useLocation, useNavigate } from 'react-router'
import AuthContainer from '../../components/AuthContainer'
import Header from '../../components/Header'

export default function AccountCreated() {
  const navigate = useNavigate()
  const location = useLocation()
  const phoneNumber = (location.state as any)?.phoneNumber || localStorage.getItem('pending_verification_phone') || ''
  
  const handleNext = () => {
    navigate('/verify-account', { state: { phoneNumber } })
  }

  return (
    <div className='min-h-screen bg-[#FFFFFF] flex flex-col'>
      <Header />
      <AuthContainer>
      <div className='w-full flex flex-col items-center text-center'>
        {/* Mail Icon */}
        <div className='w-20 h-20 bg-gray-800 rounded-2xl flex items-center justify-center mb-6'>
          <svg
            className='w-10 h-10 text-white'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z'
            />
          </svg>
        </div>

        {/* Message */}
        <h1 className='text-gray-900 text-[24px] md:text-[28px] font-semibold mb-4'>
          Account Created & OTP Sent To Your Mail
        </h1>

        {/* Next Button */}
        <button
          onClick={handleNext}
          className='w-full max-w-[300px] bg-black text-white py-3 rounded-lg text-[15px] font-medium hover:bg-gray-900 transition-colors'
        >
          Next
        </button>
      </div>
    </AuthContainer>
    </div>
  )
}
